import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Barcode Scan"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-barcode-scan',
    templateUrl: './icon-barcode-scan.component.html',
    styleUrls: ['./icon-barcode-scan.component.scss'],
    standalone: false
})
export class IconBarcodeScanComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
